/**
 * Radar Sessions must be created right before they are used, so we would
 * rather skip one than hold up registration waiting on Stripe.
 */
export async function withRadarSessionTimeout<T>(promise: Promise<T>): Promise<T> {
  const timeout = new Promise<never>((_resolve, reject) => {
    setTimeout(() => reject(new Error('Timed out creating Radar Session')), TIMEOUT_MS);
  });

  return Promise.race([promise, timeout]);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const TIMEOUT_MS = 5000;
